<template>
  <div class="page_taskSysSet">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px" size="small">
            <el-form-item label="模板名称" size="small">
              <el-input v-model="listQuery.templateNmae" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-button type="success" size="small" @click="searchHandle" style="margin-right:24px">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/staging'}">工作台</el-breadcrumb-item>
          <el-breadcrumb-item>系统设置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="addModel">添加任务模板</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" :max-height="tableHeight - 100" v-loading="loading" style="width:100%">
          <el-table-column prop="templateNmae" label="任务模板名称" min-width="100" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="busiName" label="类别" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="enabled" label="状态" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              {{ row.enabled == 1 ? '启用' : '停用' }}
            </template>
          </el-table-column>
          <el-table-column prop="priority" label="优先级" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <span v-if="row.priority == '1'" style="color: red;font-weight: 600;">紧急</span>
              <span v-if="row.priority == '4'" style="color: orange;font-weight: 600;">高</span>
              <span v-if="row.priority == '3'" style="color: blue;">中</span>
              <span v-if="row.priority == '2'" style="color: green;">低</span>
            </template>
          </el-table-column>
          <el-table-column prop="taskUser" label="任务人" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <span v-if="row.taskUser.length>20">{{getUserName(row.taskUser)}}</span>
              <span v-else>{{row.taskUser}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="通知对象" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <span v-if="row.noticeUser.length>20">{{getUserName(row.taskUser)}}</span>
              <span v-else>{{row.noticeUser}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="noticeMethod" label="通知方式" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.noticeMethod=='1' ? '企微' :row.noticeMethod=='2' ? '短信' : '' }}</template>
          </el-table-column>
          <el-table-column label="任务时限" min-width="300" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <span v-if="row.taskFromat=='1'">
                <span v-if="row.taskDeadline=='1'">无要求</span>
                <span v-if="row.taskDeadline=='2'">{{`单日任务：T+ ${row.taskDeadline2day}日任务，${row.taskDeadline2Hour}时前完成`}}</span>
                <span v-if="row.taskDeadline=='3'">
                  <span v-if="row.taskDeadline3Type=='1'">{{`多日任务：${row.taskDeadline31StartTime} ~ ${row.taskDeadline31EndTime}，截止${row.taskDeadline31Hour}时前完成`}}，</span>
                  <span v-if="row.taskDeadline3Type=='2'">{{ `多日任务：T+ ${row.taskDeadline32day1}~T+${row.taskDeadline32day2},截止${row.taskDeadline32Hour}时前完成` }}</span>
                </span>
              </span>
              <span v-else-if="row.taskFromat=='2'">
                {{`每${regularlyRepeatingTasks==1?'周' :'月'}第${row.regularlyRepeatingTasksDay}日开始，`}}
                <span v-if="row.regularlyRepeatingTaskCompletewithoutAnyDeadline=='0'">
                  {{ `T+ ${row.regularlyRepeatingTasksAddDay}日${row.regularlyRepeatingTasksHour}时前完成` }}
                </span>
                <span v-else-if="row.regularlyRepeatingTaskCompletewithoutAnyDeadline=='1'">不限日期完成</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="taskDes" label="描述" min-width="200" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="220">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="editHandle(row)">编辑</el-button>
                <!-- <el-button type="text" size="small">停用</el-button> -->
                <el-popconfirm title="请确认是否删除" @confirm="delHandle(row)" style="margin: 0 10px;">
                  <el-button type="text" slot="reference" size="small">删除</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount > 0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加 -->
    <el-dialog :title="type == 'add' ? '添加' : '编辑'" :visible.sync="addVisible" width="900px" class="res_dialog enter_dialog">
      <el-form ref="addForm" :inline="true" :model="addForm" :rules="rules" class="" label-width="100px" size="small">
        <el-form-item label="类别:" prop="busiId">
          <el-select v-model="addForm.busiId" placeholder="" style="width:300px" filterable clearable @change="changeBusiId">
            <el-option v-for="(item,index) in busiList" :key="index" :label="item.busiName" :value="item.busiId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板名称:" prop="templateNmae">
          <el-input v-model="addForm.templateNmae" size="small" style="width: 300px;" clearable></el-input>
        </el-form-item>
        <el-form-item label="优先级:">
          <div style="width: 300px;">
            <el-radio-group v-model="addForm.priority">
              <el-radio label="1">紧急</el-radio>
              <el-radio label="2">高</el-radio>
              <el-radio label="3">中</el-radio>
              <el-radio label="4">低</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="任务描述:">
          <el-input v-model="addForm.taskDes" size="small" style="width: 300px;" clearable></el-input>
        </el-form-item>
        <el-form-item label="数量:">
          <el-input v-model="addForm.task" size="small" style="width: 300px;" clearable></el-input>
        </el-form-item>
        <el-form-item label="名单附件">
          <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="fileList">
            <el-button size="small" type="primary">导入</el-button>
          </el-upload>
        </el-form-item>

        <div>
          <el-form-item label="任务人:">
            <el-radio-group v-model="taskUser">
              <el-radio label="项目客服">项目客服</el-radio>
              <el-radio label="项目业务员">项目业务员</el-radio>
              <el-radio label="项目管理员">项目管理员</el-radio>
              <el-radio label="指定人员">指定人员</el-radio>
            </el-radio-group>
            <el-select filterable v-model="taskUserList" clearable placeholder="" style="width: 240px;margin-left: 15px;" size="small" multiple v-if="taskUser=='指定人员'">
              <el-option v-for="(item, index) in userList" :key="index" :label="item.username" :value="item.userid"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="通知对象:">
            <el-radio-group v-model="noticeUser">
              <el-radio label="项目客服">项目客服</el-radio>
              <el-radio label="项目业务员">项目业务员</el-radio>
              <el-radio label="项目管理员">项目管理员</el-radio>
              <el-radio label="指定人员">指定人员</el-radio>
            </el-radio-group>
            <el-select filterable v-model="noticeUserList" clearable placeholder="" style="width: 240px;margin-left: 15px;" size="small" multiple v-if="noticeUser=='指定人员'">
              <el-option v-for="(item, index) in userList" :key="index" :label="item.username" :value="item.userid"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="通知方式:">
          <el-radio-group v-model="addForm.noticeMethod">
            <el-radio label="1">企微</el-radio>
            <el-radio label="2">短信</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="状态:">
          <div style="width: 300px;">
            <el-radio-group v-model="addForm.enabled">
              <el-radio label="1">启用</el-radio>
              <el-radio label="2">停用</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>

        <div class="info_Item_Title f_form" style="margin-bottom: 10px">
          扩展设置
        </div>
        <div>
          <el-form-item label="任务形式:">
            <el-radio-group v-model="addForm.taskFromat">
              <el-radio label="1">单次任务</el-radio>
              <el-radio label="2">定期重复任务</el-radio>
              <el-radio label="2">多次重复任务</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div v-if="addForm.taskFromat==1">
          <el-form-item label="任务时限要求:">
            <div class="taskDL">
              <el-radio-group v-model="addForm.taskDeadline">
                <el-radio label="1">无要求</el-radio>
                <el-radio label="2">
                  单日任务： T +
                  <el-input v-model="addForm.taskDeadline2day" size="small" style="width: 80px;"></el-input>
                  日任务，
                  <el-input v-model="addForm.taskDeadline2Hour" size="small" style="width: 80px;"></el-input>
                  时前完成
                </el-radio>
                <el-radio label="3">
                  多日任务：
                  <div v-if="addForm.taskDeadline==3" style="padding-left: 40px;">
                    <el-radio v-model="addForm.taskDeadline3Type" label="1">
                      <el-date-picker v-model="addForm.taskDeadline31StartTime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" style="width: 120px;"></el-date-picker>
                      ~
                      <el-date-picker v-model="addForm.taskDeadline31EndTime" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" style="width: 120px;"></el-date-picker>
                      日，截止日
                      <el-input v-model="addForm.taskDeadline31Hour" size="small" style="width: 80px;"></el-input>
                      时前完成
                    </el-radio>
                  </div>
                  <div v-if="addForm.taskDeadline==3" style="padding-left: 40px;margin-top: 10px;">
                    <el-radio v-model="addForm.taskDeadline3Type" label="2">
                      T +
                      <el-input v-model="addForm.taskDeadline32day1" size="small" style="width: 80px;"></el-input>
                      ~ T +
                      <el-input v-model="addForm.taskDeadline32day2" size="small" style="width: 80px;"></el-input>
                      截止日
                      <el-input v-model="addForm.taskDeadline32Hour" size="small" style="width: 80px;"></el-input>
                      时前完成
                    </el-radio>
                  </div>
                </el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
        </div>
        <div v-if="addForm.taskFromat==2" style="padding-left: 80px;">
          <el-form-item label="">
            每
            <el-select v-model="addForm.regularlyRepeatingTasks" placeholder="" style="width:80px">
              <el-option label="周" :value="1"></el-option>
              <el-option label="月" :value="2"></el-option>
            </el-select>
            第
            <el-input v-model="addForm.regularlyRepeatingTasksDay" size="small" style="width: 80px;"></el-input>
            日开始
            <el-radio-group v-model="addForm.regularlyRepeatingTaskCompletewithoutAnyDeadline">
              <el-radio label="0">
                T +
                <el-input v-model="addForm.regularlyRepeatingTasksAddDay" size="small" style="width: 80px;"></el-input>
                日
                <el-input v-model="addForm.regularlyRepeatingTasksHour" size="small" style="width: 80px;"></el-input>
                时前完成
              </el-radio>
              <el-radio label="1">不限日期完成</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmAdd" :loading="isBtnLoading" size="small">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        tableHeight: Number(document.body.clientHeight),
        listQuery: {
          pageModel: {
            rows: 10,
            page: 1,
            orderInput: [],
          },
          templateNmae: ''
        },
        busiList: [],
        userList: [],
        addForm: {
          id: '',
          busiId: '',
          busiName: '', //任务类名
          projectId: 0,
          projectName: '',
          templateNmae: '', //模板名称
          priority: '', //优先级存中文 1.紧急 2.高 3中 4 低
          task: 0, //任务数
          taskListUrl: '', //任务名单，上传上来文件 第一列为序号，第二列为记录主键，比如身份证号
          taskDes: 0, //任务描述
          taskUser: '', //任务人：存中文 项目客服 项目业务员 项目管理员 指定人员
          noticeUser: '', //通知对象 ：存中文 项目客服 项目业务员 项目管理员 指定人员
          noticeMethod: '', //通知方式：存中文 1企微,2短信
          enabled: 1, //状态 存中文 1为开启 0为停用
          taskFromat: '', //任务形式，1.单次任务，2.定期重复任务 3.多次重复任务
          taskDeadline: '', //任务时限要求 1.为无要求，2为单日任务 3.多日任务
          taskDeadline2day: '', //任务时限要求 单任务加多少天
          taskDeadline2Hour: '', //任务时限要求 单任务 N时前完成 24小时制
          taskDeadline3Type: '', //多日任务选项 1为上，2为下
          taskDeadline31StartTime: '', //多日任务选项1开始时间
          taskDeadline31EndTime: '', //多日任务选项1结束时间
          taskDeadline31Hour: '', //多日任务 N时前完成 24小时制
          taskDeadline32day1: '', //多日任务选项2 天1
          taskDeadline32day2: '', //多日任务选项2 天2
          taskDeadline32Hour: '', //多日任务选项2 小时
          regularlyRepeatingTasks: '', //定期重复任务 1为周2为月
          regularlyRepeatingTasksDay: '', //定期重复任务N天开始
          regularlyRepeatingTasksAddDay: '', //定期重复任务T+N日
          regularlyRepeatingTasksHour: '', //定期重复任务N时前完成
          regularlyRepeatingTaskCompletewithoutAnyDeadline: '' //定期重复任务 不限日期完成为1 是,为0是
        },
        taskUser: '',
        taskUserList: [],
        noticeUser: '',
        noticeUserList: [],
        addVisible: false,
        isBtnLoading: false,
        fileList: [],
        tableData: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        projectList: [], //项目列表
        type: '',
        rules: {
          bankName: {
            required: true,
            message: '请选择银行',
            trigger: 'change'
          },

        },
      }
    },
    created() {
      this.getList();
      this.GetAllLowerUserIdList();
      this.getBusiList();
      // this.getButtonPower();
    },
    methods: {
      checkPermission,
      getBusiList() {
        let str = `?id=1`
        xz.ArdCurStatGetFun('GetTaskBoardPermcc', str).then(res => {
          if (res.status == 'ok') {
            this.busiList = res.data;
          } else {
            this.busiList = [];
          }
        })
      },
      //获取下级人员列表
      GetAllLowerUserIdList() {
        let str = `?pageNum=1&pageSize=1000&Username=`
        xz.ArdCurStatGetFun('GetAllLowerUserIdList', str).then(res => {
          if (res.status == 'ok') {
            this.userList = res.data.date;
          } else {
            this.userList = [];
          }
        })
      },
      currentChange(val) {
        this.listQuery.pageModel.page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageModel.page = 1;
        this.listQuery.pageModel.rows = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.pageModel.page = 1;
        this.getList();
      },
      getList() {
        this.loading = true;
        xz.ArdCurStat(this.listQuery, 'GetTaskTempPageList').then(res => {
          if (res.status === 'ok') {
            res.data.data.forEach((e, index) => {
              // 解析 msg10 的 JSON 字符串
              const parsedMsg10 = JSON.parse(e.msg10);
              delete parsedMsg10.Id;
              // 将对象的所有键首字母转为小写
              const toCamelCase = (obj) => {
                const newObj = {};
                for (const key in obj) {
                  // 首字母转小写，其余保持不变
                  const newKey = key.charAt(0).toLowerCase() + key.slice(1);
                  newObj[newKey] = obj[key];
                }
                return newObj;
              };

              // 转换所有字段首字母为小写
              const lowerCaseKeys = toCamelCase(parsedMsg10);
              const result = {
                ...e,
                ...lowerCaseKeys,
                // 如果不想保留 msg10，可以注释掉下面这行；如果想保留，取消注释
                // msg10: data.msg10
              };
              this.$set(res.data.data, index, result);
              if (index == res.data.data.length - 1) {
                this.tableData = res.data.data;
                console.log(this.tableData);
              }
            });
            this.totalCount = res.data.pageModel.totalCount;
          } else {
            this.tableData = [];
            this.totalCount = 0;
          }
          this.loading = false;
        }).catch(error => {
          console.error('Error fetching task settings:', error);
          this.tableData = [];
          this.totalCount = 0;
          this.loading = false;
        });
      },
      addModel() {
        this.type = 'add';
        this.addForm = this.$options.data.call(this).addForm;
        this.fileList = [];
        this.taskUser = '';
        this.noticeUser = '';
        this.taskUserList = [];
        this.noticeUserList = [];
        this.addVisible = true;
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 1 个文件`);
      },
      // 删除附件
      handleFileRemove() {
        this.addForm.taskListUrl = '';
      },
      // 上传
      success_handle(file) {
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData, file);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.addForm.taskListUrl = res;
          } else {
            this.addForm.taskListUrl = ''
          }
        });
      },
      editHandle(row) {
        this.type = 'edit'
        this.addForm = row;
        if (row.taskUser.length > 20) {
          this.taskUser = '指定人员';
          this.taskUserList = row.taskUser.split(',');
        }
        if (row.noticeUser.length > 20) {
          this.noticeUser = '指定人员';
          this.noticeUserList = row.noticeUser.split(',');
        }
        console.log(row);
        this.isBtnLoading = false;
        this.addVisible = true;
      },
      changeBusiId(val) {
        if (val != null && val) {
          let item = this.busiList.find(e => e.busiId == val);
          this.addForm.busiName = item.busiName;
        }
      },
      confirmAdd() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            if (this.taskUser == '指定人员') {
              if (this.taskUserList.length > 0) {
                this.addForm.taskUser = this.taskUserList.toString();
              } else {
                this.$message.error('请选择任务人指定人员！');
                return
              }
            } else {
              this.addForm.taskUser = this.taskUser;
            }
            if (this.noticeUser == '指定人员') {
              if (this.noticeUserList.length > 0) {
                this.addForm.noticeUser = this.noticeUserList.toString();
              } else {
                this.$message.error('请选择通知对象指定人员！');
                return
              }
            } else {
              this.addForm.taskUser = this.taskUser;
            }
            this.isBtnLoading = true;
            xz.ArdCurStat(this.addForm, 'UpdataTaskTemp').then(res => {
              if (res.status == 'ok') {
                this.getList();
                this.addVisible = false;
                this.isBtnLoading = false;
                this.$message.success('添加成功！')
              } else {
                this.isBtnLoading = false;
                this.$message.error(res.msg);
              }
            })
          }
        })
      },
      stopHandel(status) {},
      delHandle(row) {
        let d = {
          id: row.id,
          isDeleted: true
        }
        this.loading = true;
        xz.ArdCurStat(d, 'UpdataTaskTemp').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.loading = false;
            this.$message.success('删除成功！')
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        })
      },
      //根据ID获取用户名
      getUserName(val) {
        return this.userList
          .filter(user => val.includes(user.userid))
          .map(user => user.username)
          .join('，');
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .calTitle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }

  .calList {
    padding-left: 40px;
    margin-top: 20px;
  }

  .calItem {
    margin-bottom: 10px;
  }

  .timeTitle {
    padding: 0 20px;
  }

  .timeItemTile {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .info_Item_Title {
    line-height: 33px;
    font-family: "微软雅黑 Bold", "微软雅黑 Regular", 微软雅黑, sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 14px;
    margin-right: 100px;
  }

  .f_form {
    border-bottom: 1px solid #ddd;
  }
</style>
<style>
  .page_taskSysSet .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_taskSysSet .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_taskSysSet .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_taskSysSet .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_taskSysSet .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_taskSysSet .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .taskDL .el-radio {
    display: block;
    /* 使每个 radio 元素独占一行 */
    height: 32px;
    line-height: 32px;
  }
</style>